export const GenderEnum = ["male", "female", "others"];
